import { IEventItem } from '../../store/player/events/store';

export const getEventAvailableEntries = (event: IEventItem) => {
  const { totalPlayers, enrollments } = event;

  const activeEnrollments = enrollments.filter(enrollment => enrollment.status === 'active');
  const entries = totalPlayers - activeEnrollments.length;

  return entries < 0 ? 0 : entries;
};
